import { App } from 'ovee.js';
import OveeBarba from '@ovee.js/barba';
import { isIOS, isAndroid } from '@/tools/browser';
import InViewport from './components/InViewport';
import SliderMain from './components/SliderMain';
import PageLang from './components/PageLang';
import CollapsingHeader from './components/CollapsingHeader';
import GoogleMaps from './components/GoogleMaps';
import FormBase from './components/FormBase';
import SliderGallery from './components/SliderGallery';
import ProductDemo from './components/ProductDemo';
import AccordionBase from './components/AccordionBase';
import SliderProducts from './components/SliderProducts';
import SliderArticles from './components/SliderArticles';
import NavToggle from './components/NavToggle';
import FiltersTrigger from './components/FiltersTrigger';
import LazyLoad from './components/LazyLoad';
import HeroAnimation from './components/HeroAnimation';
import DownloadInfo from './components/DownloadInfo';
import MoviesContainer from './components/MoviesContainer';
import Fix100vh from './modules/Fix100vh';
import InitScroll from './modules/InitScroll';
import defaultTransition from './transitions/default';
var root = document.body;
var app = new App({
  config: {
    baseUrl: root.dataset.baseHref
  },
  components: [InViewport, SliderMain, PageLang, CollapsingHeader, GoogleMaps, FormBase, SliderGallery, ProductDemo, AccordionBase, SliderProducts, SliderArticles, NavToggle, FiltersTrigger, LazyLoad, HeroAnimation, DownloadInfo, MoviesContainer]
});
app.use(OveeBarba, {
  transitions: [defaultTransition],
  timeout: 20000,
  preventRunning: true,
  usePrefetch: isIOS() && !isAndroid(),
  hooks: {
    after: function after() {
      if (global.dataLayer !== undefined) {
        try {
          global.dataLayer.push({
            event: 'content-view',
            'content-name': global.location.pathname
          }); // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    }
  }
});
app.use(Fix100vh);
app.use(InitScroll);
app.run(root);